import { usePublicLang } from "@/contexts/PublicLangContext";

// Fix E (2026-09-09): franja informativa de financiamiento (ej. Cherry),
// pedida por la clinica. Solo muestra e enlaza al formulario del proveedor;
// SIN integracion por API.
export default function FinancingBanner({ clinic }) {
  const { t } = usePublicLang();
  if (!clinic?.financing_enabled) return null;

  return (
    <section className="py-10 px-5" style={{ backgroundColor: "var(--brand-dark)" }} data-testid="landing-financing-banner">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
        <div>
          <p className="font-serif text-xl text-white">{t("landing.financing.title")}</p>
          {(clinic.financing_note || clinic.financing_provider) && (
            <p className="text-sm text-[#D8C3A5] mt-1">
              {clinic.financing_note}
              {clinic.financing_note && clinic.financing_provider ? " · " : ""}
              {clinic.financing_provider}
            </p>
          )}
        </div>
        {clinic.financing_url && (
          <a
            href={clinic.financing_url}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 bg-[var(--brand-accent)] text-white text-[11px] font-medium uppercase tracking-[0.16em] px-6 py-3 rounded-md hover:opacity-90 active:scale-95 transition-all"
            data-testid="landing-financing-link"
          >
            {t("landing.financing.cta")}
          </a>
        )}
      </div>
    </section>
  );
}
